import React, { useState } from "react";
import { Paper, Stack, Typography, Box, Chip, Skeleton } from "@mui/material";
import PeopleIcon from "@mui/icons-material/People";

import PatientFilters from "./PatientFilters";
import PatientTable from "./PatientTable";
import InfoButton from "./InfoButton";
import { HELP_CONTENT } from "../../constants/clinicalHelpContent";

/**
 * Panel 3: My Patients Worklist
 * Tabla filtrable de pacientes con triage sort.
 */
export default function PanelMyPatients({ patients, pcps, loading, onCreateTask }) {
  const [filters, setFilters] = useState({
    search: "",
    healthStatus: "All",
    lastVisit: "All",
    provider: "All",
  });

  const patientList = patients?.patients || patients || [];
  const totalPatients = patientList.length;

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2.5,
        borderRadius: 3,
        border: "1px solid",
        borderColor: "divider",
      }}
    >
      <Stack spacing={2}>
        {/* Header */}
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Stack direction="row" alignItems="center" spacing={1}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: 28,
                height: 28,
                borderRadius: 1.5,
                bgcolor: "#F0FDF4",
                color: "#16A34A",
              }}
            >
              <PeopleIcon sx={{ fontSize: 16 }} />
            </Box>
            <Typography variant="subtitle2" fontWeight={700}>
              My Patients
            </Typography>
            <InfoButton helpContent={HELP_CONTENT.myPatients} />
            {!loading && (
              <Chip
                label={`${totalPatients.toLocaleString()} showing`}
                size="small"
                sx={{
                  height: 22,
                  fontSize: "0.7rem",
                  fontWeight: 600,
                  bgcolor: "#F1F5F9",
                  color: "#475569",
                }}
              />
            )}
          </Stack>
        </Stack>

        {/* Filters */}
        {loading ? (
          <Stack direction="row" spacing={1.5}>
            <Skeleton variant="rounded" width={200} height={36} />
            <Skeleton variant="rounded" width={130} height={36} />
            <Skeleton variant="rounded" width={130} height={36} />
          </Stack>
        ) : (
          <PatientFilters
            filters={filters}
            onFilterChange={setFilters}
            pcps={pcps}
          />
        )}

        {/* Table */}
        <PatientTable
          patients={patientList}
          filters={filters}
          loading={loading}
          onCreateTask={onCreateTask}
        />
      </Stack>
    </Paper>
  );
}
